<template>
  <div>
    <div class="row" v-if="!isSearch && queriedData.length == 0">
      <h4 v-if="initialized">No registrations exist for {{accountData.activeBrand.data.name}}.</h4>
      <h4 v-if="!initialized">Loading...</h4>
    </div>
    <div class="row" v-if="isSearch || queriedData.length > 0">
      <div class="pull-right" v-if="!isSearch">
        <button v-if="!csvLoading" class="btn btn-sm" @click.prevent="downloadRegCsv()">Download CSV</button>
        <button v-if="csvLoading" style="margin-top:5px" type="button" class="btn btn-sm" disabled="disabled">
          <span class="btn-label">
            <i class="fa fa-circle-o-notch fa-spin"></i>
          </span>
          Processing...
        </button>
      </div>
      <div class="col-sm-4 pagination-info">
        <el-select
          v-if="!isSearch"
          class="select-default"
          v-model="watchPerPage"
          placeholder="Per page">
          <el-option
            class="select-default"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="perPageLabel(item)"
            :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="col-sm-4">
        <form role="search" class="navbar-form navbar-left navbar-search-form" _lpchecked="1">
          <div class="input-group"><input type="text" v-model="searchQuery" value="" placeholder="Search..." class="form-control" style="background-color: #fff;">
            <span class="input-group-addon"><i class="fa fa-search"></i></span>
          </div>
        </form>
      </div>
      <div class="col-sm-4">
        <div class="pull-right" v-if="!isSearch">
          <ul class="pagination">
            <li class="page-item prev-page" :class="{disabled: pagination.currentPage === 1}">
              <a v-if="pagination.currentPage !== 1" class="page-link" aria-label="Previous" @click="queryData('prev')">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </a>
              <a v-if="pagination.currentPage === 1" class="page-link" aria-label="Previous" href="javascript:void(0);">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </a>
            </li>
            <li class="page-pre next-page" :class="{disabled: pagination.isLastPage}">
              <a v-if="!pagination.isLastPage" class="page-link" aria-label="Next" @click="queryData('next')">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
              <a v-if="pagination.isLastPage" class="page-link" aria-label="Next" href="javascript:void(0);">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
        <!-- <p-pagination class="pull-right"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="pagination.total">
        </p-pagination> -->
      </div>
    </div>
    <div class="row" v-if="queriedData.length > 0">
      <div class="col-lg-4 col-md-6" v-for="reg in queriedData" :key="reg.id">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-xs-5">
                <div class="img-container">
                  <img v-if="reg.productLoaded" :src="reg.imageUrl" width="140" height="140">
                  <span v-if="!reg.productLoaded">loading...</span>
                </div>
              </div>
              <div class="col-xs-7">
                <p v-if="reg.productLoaded"><strong>{{limitChars(reg.productName)}}</strong></p>
                <p v-if="!reg.productLoaded"><strong>loading...</strong></p>
                {{reg.firstName}} {{reg.lastName}}<br />
                {{reg.email}}<br>
                {{addressRegion(reg)}}<br>
                {{reg.country}}&nbsp;
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr/>
            <i class="ti-time"></i> {{reg.friendlyDate}}
            <button @click.prevent="regDetailsPopup(reg)" class="btn btn-fill btn-sm pull-right">View Details</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!isSearch && queriedData.length > 0">
      <div class="col-sm-6 pagination-info">
        <el-select
          class="select-default"
          v-model="watchPerPage"
          placeholder="Per page">
          <el-option
            class="select-default"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="perPageLabel(item)"
            :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="col-sm-6">
        <div class="pull-right">
          <ul class="pagination">
            <li class="page-item prev-page" :class="{disabled: pagination.currentPage === 1}">
              <a class="page-link" aria-label="Previous" @click="queryData('prev')">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </a>
            </li>
            <li class="page-pre next-page" :class="{disabled: pagination.isLastPage}">
              <a class="page-link" aria-label="Next" @click="queryData('next')">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import _ from 'lodash'
  import moment from 'moment'
  import users from '../Tables/users'
  import firebase from 'firebase'
  import db from '@/components/firebase/init'
  import Papa from 'papaparse'
  import axios from 'axios'
  import algoliasearch from 'algoliasearch'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  const algolia = algoliasearch(
    'RQUCV3WZ1Q',
    '1f59c67aacc900322f92fb575c71e5c0'
  )
  export default{
    components: {
      PPagination
    },
    props: ['accountData'],
    mixins: [toolboxMixin],
    computed: {
      queriedData () {
        return this.tableData
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        return this.pagination.total
      }
      // watchPerPage () {
      //   return this.pagination.perPage * this.pagination.currentPage
      // }
    },
    data () {
      return {
        user: {},
        initialized: false,
        isSearch: false,
        csvLoading: false,
        pagination: {
          perPage: 12,
          currentPage: 1,
          perPageOptions: [6, 12, 24, 48],
          total: 0,
          startAfter: false,
          endBefore: false,
          isLastPage: false,
          pageCursors: []
        },
        searchQuery: '',
        propsToSearch: ['authCode', 'email', 'firstName'],
        tableColumns: [
          {
            prop: 'authCode',
            label: 'Auth Code',
            minWidth: 250
          },
          {
            prop: '',
            label: 'Auth Code ID',
            minWidth: 100
          },
          {
            prop: 'city',
            label: 'City',
            minWidth: 120
          }
        ],
        tableData: [],
        regDocMap: new Map(),
        products: new Map(),
        retailers: new Map(),
        watchPerPage: 12,
        authCodes: new Map(),
        authCodeBatches: new Map()
      }
    },
    methods: {
      async init () {
        this.user = await this.getCurrentUser()
        this.queryData(false)
      },
      async queryData (useCursor) {
        if (_.isEmpty(this.user)) return []

        this.initialized = false
        this.isSearch = false
        this.tableData = []

        let data = {}
        data.userToken = await firebase.auth().currentUser.getIdToken()
        data.accountId = this.user.accountId
        data.perPage = this.pagination.perPage
        data.pageNum = this.pagination.currentPage
        data.brandId = this.accountData.activeBrand.id

        let ref = db.collection(`brands/${this.accountData.activeBrand.id}/authCodeRegistrations`)
        if (useCursor === 'next') {
          console.log('startAfter')
          this.pagination.currentPage = this.pagination.currentPage + 1
          ref = ref.orderBy('createdAt', 'desc').startAfter(this.pagination.pageCursors[this.pagination.currentPage - 2].startAfter).limit(this.pagination.perPage + 1)
        } else if (useCursor === 'prev') {
          this.pagination.currentPage = this.pagination.currentPage - 1
          ref = ref.orderBy('createdAt', 'desc').startAt(this.pagination.pageCursors[this.pagination.currentPage - 1].startAt).limit(this.pagination.perPage + 1)
        } else { // === false
          ref = ref.orderBy('createdAt', 'desc').limit(this.pagination.perPage + 1)
          this.pagination.currentPage = 1
        }
        if (this.pagination.pageCursors.length < this.pagination.currentPage) {
          this.pagination.pageCursors.push({
            startAt: false,
            startAfter: false
          })
        }
        this.pagination.startAfter = false
        this.pagination.startBefore = false
        let qs = await ref.get()
        let i = 0
        this.pagination.isLastPage = true
        for (const regDoc of qs.docs) {
          i++
          if (i > this.pagination.perPage) {
            this.pagination.isLastPage = false
            break
          }
          if (this.pagination.pageCursors[this.pagination.currentPage - 1].startAt === false) this.pagination.pageCursors[this.pagination.currentPage - 1].startAt = regDoc
          this.pagination.pageCursors[this.pagination.currentPage - 1].startAfter = regDoc
          let obj = regDoc.data()
          obj.productId = regDoc.data().productId
          obj.id = regDoc.id
          obj.productLoaded = false
          // obj.imageUrl = this.products.get(regDoc.data().productId).imageUrl
          // obj.productName = this.products.get(regDoc.data().productId).name
          obj.friendlyDate = moment(regDoc.data().createdAtMillis).format('LL')
          this.tableData.push(obj)
          this.regDocMap.set(obj.id, this.tableData.length - 1)
          this.loadProduct(regDoc.id, regDoc.data().brandId, regDoc.data().productId)
          this.loadAuthCodeAndBatch(regDoc.id, regDoc.data().brandId, regDoc.data().authCodeId)
        }
        console.log(this.tableData)
        this.initialized = true
      },
      async loadProduct (regId, brandId, prodId) {
        if (this.products.get(prodId) === undefined) {
          let prodDoc = await db.collection(`brands/${brandId}/products`).doc(prodId).get()
          let img = await this.prodImgUrl(prodDoc.id, prodDoc.data(), '140x140x')
          this.products.set(prodDoc.id, {
            name: prodDoc.data().name,
            imageUrl: img,
            data: prodDoc.data()
          })
        }
        this.tableData[this.regDocMap.get(regId)].imageUrl = this.products.get(prodId).imageUrl
        this.tableData[this.regDocMap.get(regId)].productName = this.products.get(prodId).name
        this.tableData[this.regDocMap.get(regId)].productLoaded = true
      },
      async loadAuthCodeAndBatch (regId, brandId, authCodeId) {
        if (this.authCodes.get(regId) === undefined) {
          console.log('getting authCode')
          console.log('authCodeId', authCodeId, process.env.API1_ROOT_URL)
          let response = await axios.get(process.env.API1_ROOT_URL + '/auth-code-alt/' + authCodeId)
          console.log('authCodeResponse in loadAuthCodeAndBatch', response)
          // let authCodeDoc = await db.collection('authCodes').doc(authCodeId).get()
          // console.log('authCode data', authCodeDoc.data())
          let authCode = {
            id: response.data.data.alt_id,
            data: response.data.data
          }
          console.log('setting authCode', authCode)
          this.authCodes.set(regId, authCode)
          if (this.authCodeBatches.get(this.authCodes.get(regId).data.auth_code_batch_id) === undefined) {
            console.log('loading up batch id in brand', this.authCodes.get(regId).data.auth_code_batch_id, brandId)
            let batchDoc = await db.collection(`brands/${brandId}/authCodeBatches`).doc(this.authCodes.get(regId).data.auth_code_batch_id).get()
            if (!batchDoc.exists) {
              console.log('failed to load batch from db: batchId, brand', this.authCodes.get(regId).data.auth_code_batch_id, brandId)
            } else {
              console.log('got batch: batchDoc, reg, batch', batchDoc, regId, this.authCodes.get(regId).data.auth_code_batch_id, batchDoc.data())
              this.authCodeBatches.set(this.authCodes.get(regId).data.auth_code_batch_id, {
                id: batchDoc.id,
                data: batchDoc.data()
              })
            }
          }
        }
      },
      // async loadProduct (brandId, prodId) {
      //   if (this.products.get(prodId) === undefined) {
      //     let prodDoc = await db.collection(`brands/${rbrandId}/products`).doc(prodId).get()
      //     let img = await this.prodImgUrl(prodId, prodDoc.data(), '140x140x')
      //     this.products.set(prodId, {
      //       name: prodDoc.data().name,
      //       imageUrl: img,
      //       data: prodDoc.data()
      //     })
      //   }
      // },
      // async loadAuthCode (regId, authCodeId) {
      //   if (this.authCodes.get(regId) === undefined) {
      //     let authCodeDoc = await db.collection('authCodes').doc(authCodeId).get()
      //     this.authCodes.set(regId, {
      //       id: authCodeDoc.id,
      //       data: authCodeDoc.data()
      //     })
      //   }
      // },
      prettyAddress (regRecord) {
        let address = ''
        if (regRecord.address1) address += regRecord.address1
        if (regRecord.address2) address += '<br>' + regRecord.address2
        if (regRecord.city || regRecord.state || regRecord.zip || regRecord.country) {
          let region = ''
          if (regRecord.city) region += regRecord.city
          if (regRecord.state) {
            if (region === '') region += regRecord.state
            else region += ', ' + regRecord.state
          }
          if (regRecord.zip) {
            if (region === '') region += regRecord.zip
            else region += ' ' + regRecord.zip
          }
          if (regRecord.country) {
            if (region === '') region += regRecord.country
            else region += ' ' + regRecord.country
          }
          if (region !== '') region = '<br>' + region
          address += region
        }
        return address
      },
      addressRegion (regRecord) {
        let region = ''
        if (regRecord.city) region += regRecord.city
        if (regRecord.state) {
          if (region === '') region += regRecord.state
          else region += ', ' + regRecord.state
        }
        return region
      },
      async downloadRegCsv () {
        this.csvLoading = true

        let brands = new Map()
        let products = new Map()
        let authCodes = new Map()
        let authCodeBatches = new Map()
        let retailers = new Map()

        let data = {}
        data.userToken = await firebase.auth().currentUser.getIdToken()
        data.accountId = this.user.accountId
        let getRegistrationsRaw = firebase.functions().httpsCallable('getRegistrationsRaw')
        let result = await getRegistrationsRaw(data)
        let regArray = []

        for (const regDoc of result.data.authCodeRegistrations) {
          // console.log('dealing with registration', regDoc)
          if (products.get(regDoc.data.productId) === undefined) {
            // console.log('getting product', regDoc.data.productId)
            let prodDoc = await db.collection(`brands/${regDoc.data.brandId}/products`).doc(regDoc.data.productId).get()
            products.set(prodDoc.id, prodDoc.data())
          }
          if (brands.get(regDoc.data.brandId) === undefined) {
            // console.log('getting brand', regDoc.data.brandId)
            let brandDoc = await db.collection('brands').doc(regDoc.data.brandId).get()
            brands.set(brandDoc.id, brandDoc.data())
          }
          if (authCodes.get(regDoc.data.authCodeId) === undefined) {
            // console.log('getting auth code', regDoc.data.authCodeId)
            // let authCodeDoc = await db.collection('authCodes').doc(regDoc.data.authCodeId).get()
            // authCodes.set(authCodeDoc.id, authCodeDoc.data())
            let response = await axios.get(process.env.API1_ROOT_URL + '/auth-code-alt/' + regDoc.data.authCodeId)
            // console.log('authCodeResponse', response)
            let authCode = {
              id: response.data.data.alt_id,
              data: response.data.data
            }
            this.authCodes.set(regId, authCode)
          }
          let retailerName = ''
          if (authCodes.get(regDoc.data.authCodeId).data.retailer_id) {
            if (retailers.get(authCodes.get(regDoc.data.authCodeId).data.retailer_id) === undefined) {
              // console.log('getting retailer', authCodes.get(regDoc.data.authCodeId).retailerId)
              let retailerDoc = null
              if (authCodes.get(regDoc.data.authCodeId).data.retailer_id.substring(0, 4) === 'glo_') {
                retailerDoc = await db.collection('globalRetailers').doc(authCodes.get(regDoc.data.authCodeId).data.retailer_id).get()
              } else {
                retailerDoc = await db.collection(`accounts/${this.user.accountId}/retailers`).doc(authCodes.get(regDoc.data.authCodeId).data.retailer_id).get()
              }
              retailers.set(retailerDoc.id, retailerDoc.data())
            }
            retailerName = retailers.get(authCodes.get(regDoc.data.authCodeId).data.retailer_id).name
          }
          let reg = {
            product: products.get(regDoc.data.productId).name,
            brand: brands.get(regDoc.data.brandId).name,
            retailer: retailerName,
            first_name: regDoc.data.firstName,
            last_name: regDoc.data.lastName,
            email: regDoc.data.email,
            address1: regDoc.data.address1,
            address2: regDoc.data.address2,
            city: regDoc.data.city,
            state: regDoc.data.state,
            zip: regDoc.data.zip,
            country: regDoc.data.country,
            created_at: moment(regDoc.data.createdAtMillis).format('LL')
          }
          regArray.push(reg)
        }
        let csvString = Papa.unparse(regArray)
        let filename = 'registrations_' + moment().format('MM-DD-YYYY') + '.csv'
        this.downloadCsv(csvString, filename)
        this.csvLoading = false
      },
      perPageLabel (item) {
        return item + ' per page'
      },
      async regDetailsPopup (regRecord) {
        let product = this.products.get(regRecord.productId)
        let authCode = this.authCodes.get(regRecord.id)
        let batch = this.authCodeBatches.get(authCode.data.auth_code_batch_id)
        console.log('get batch', batch)
        let prodDetailsHtml = `<b>Registration Date:</b> ${regRecord.friendlyDate}`
        if (product.data.size) prodDetailsHtml += `<br><b>Size:</b> ${product.data.size}`
        if (product.data.color) prodDetailsHtml += `<br><b>Color:</b> ${product.data.color}`
        if (product.data.style) prodDetailsHtml += `<br><b>Style:</b> ${product.data.style}`
        if (product.data.upc) prodDetailsHtml += `<br><b>UPC:</b> ${product.data.upc}`
        if (product.data.sku) prodDetailsHtml += `<br><b>SKU:</b> ${product.data.sku}`
        if (product.data.amazonComFnsku) prodDetailsHtml += `<br><b>AMZ FBA FNSKU:</b> ${product.data.amazonComFnsku}`
        if (regRecord.retailerId) {
          if (this.retailers.get(regRecord.retailerId) === undefined) {
            // console.log('getting retailer', authCodes.get(regDoc.data.authCodeId).retailerId)
            let retailerDoc = null
            if (regRecord.retailerId.substring(0, 4) === 'glo_') {
              retailerDoc = await db.collection('globalRetailers').doc(regRecord.retailerId).get()
            } else {
              retailerDoc = await db.collection(`accounts/${this.user.accountId}/retailers`).doc(regRecord.retailerId).get()
            }
            this.retailers.set(retailerDoc.id, retailerDoc.data())
          }
          prodDetailsHtml += `<br><b>Retailer:</b> ${this.retailers.get(regRecord.retailerId).name}`
        }
        if (batch.data.lotNum) {
          prodDetailsHtml += `<br><b>Batch / Lot Num:</b> ${batch.data.lotNum}`
        }
        prodDetailsHtml += '<br>'
        if (regRecord.firstName) prodDetailsHtml += `<br><b>First Name:</b> ${regRecord.firstName}`
        if (regRecord.lastName) prodDetailsHtml += `<br><b>Last Name:</b> ${regRecord.lastName}`
        if (regRecord.email) prodDetailsHtml += `<br><b>Email:</b> ${regRecord.email}`
        if (regRecord.address1) prodDetailsHtml += `<br><b>Address 1:</b> ${regRecord.address1}`
        if (regRecord.address2) prodDetailsHtml += `<br><b>Address 2:</b> ${regRecord.address2}`
        if (regRecord.city) prodDetailsHtml += `<br><b>City:</b> ${regRecord.city}`
        if (regRecord.state) prodDetailsHtml += `<br><b>State:</b> ${regRecord.state}`
        if (regRecord.zip) prodDetailsHtml += `<br><b>Zip:</b> ${regRecord.zip}`
        if (regRecord.country) prodDetailsHtml += `<br><b>Country:</b> ${regRecord.country}`
        swal.fire({
          title: `<strong>Product Registration Details</strong>`,
          html:
            `<b>Product:</b> ${regRecord.productName}<br>` +
            prodDetailsHtml,
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: 'Close'
        })
      },
      limitChars (x) {
        if (x.length > 20) return x.substring(0, 17) + '...'
        return x
      },
      async searchRegistrations (query) {
        if (query === '') {
          this.queryData(false)
        } else {
          this.isSearch = true
          let iString = `brands_${this.accountData.activeBrand.id}_authCodeRegistrations`
          console.log('algolia index', iString)
          let index = algolia.initIndex(iString)
          let result = await index.search(query)

          this.tableData = []
          this.regDocMap = new Map()
          for (const docData of result.hits) {
            let obj = docData
            obj.id = docData.objectID
            obj.productLoaded = false
            obj.friendlyDate = moment(docData.createdAtMillis).format('LL')
            this.tableData.push(obj)
            this.regDocMap.set(obj.id, this.tableData.length - 1)
            this.loadProduct(obj.id, obj.brandId, obj.productId)
            this.loadAuthCodeAndBatch(obj.id, obj.brandId, obj.authCodeId)
          }
        }
      }
    },
    watch: {
      watchPerPage: function (newFrom, oldFrom) {
        this.pagination.perPage = this.watchPerPage
        this.queryData()
      },
      searchQuery: function (newFrom, oldFrom) {
        this.searchRegistrations(newFrom)
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/RegistrationsCards.vue